import React, { useState, useEffect, useRef, useCallback, useMemo} from 'react'
import ReactTable from "react-table";
import {BotonRemovePequeño, BotonMenosPequeño, BotonAddPequeño} from '../Plantillas/Botones';
import {decimalAdjust} from "../../Global";

const EditableQuantityInput = React.memo(({ item, initialValue, onQuantityChange }) => {
    const [localValue, setLocalValue] = useState(initialValue);
    const [isPending, setIsPending] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        setLocalValue(initialValue);
    }, [initialValue]);

    const handleChange = useCallback((e) => {
        const newValue = e.target.value;
        setLocalValue(newValue);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        setIsPending(true);

        timeoutRef.current = setTimeout(() => {
            const originalQuantity = item.Cantidad;
            const quantityDifference = parseFloat(newValue) - originalQuantity;
            
            if (quantityDifference !== 0) {
                onQuantityChange(item, quantityDifference);
            }
            
            setIsPending(false);
        }, 2500);
    }, [item, onQuantityChange]);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <input
                type="number"
                value={localValue}
                onChange={handleChange}
                style={{
                    width: '70px',
                    textAlign: 'right',
                    border: isPending ? '1px solid #ffa500' : '1px solid #ccc',
                    borderRadius: '3px',
                    padding: '2px 4px',
                    fontSize: '13px',
                    backgroundColor: isPending ? '#fff8e1' : 'white',
                    transition: 'border-color 0.2s ease, background-color 0.2s ease'
                }}
                step="0.01"
                min="0"
            />
            {isPending && (
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: '-20px',
                        transform: 'translateY(-50%)',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        border: '2px solid #ffa500',
                        borderTop: '2px solid transparent',
                        animation: 'spin 1s linear infinite'
                    }}
                />
            )}
            <style>
                {`
                    @keyframes spin {
                        0% { transform: translateY(-50%) rotate(0deg); }
                        100% { transform: translateY(-50%) rotate(360deg); }
                    }
                `}
            </style>
        </div>
    );
});

function MovimientoAlmacenDetalle(props) {

    const [rows, setRows] = useState([])

    useEffect(() => {
        setRows(props.data.sort((a, b) => (a.IdDetalleMovimientosAlmacen < b.IdDetalleMovimientosAlmacen) ? 1 : -1))
    }, [props.data])

    const handleQuantityUpdate = useCallback((item, quantityDifference) => {
        if (props.handleAddQuantityItem) {
            props.handleAddQuantityItem(item, quantityDifference);
        }
    }, [props.handleAddQuantityItem])

    const columns = useMemo(() => [
        {
            Header: "Producto",
            accessor: "NombreProductoConPresentacion",
            minWidth: 215
        },
        {
            Header: "Tipo Transacción",
            accessor: "tipoTransaccion",
            maxWidth: 140,
        },
        {
            Header: "Precio con IGV/EXO/INA",
            accessor: "Precio",
            maxWidth: 110,
            Cell: row => <div style={{textAlign: "right"}}>{row.value}</div>

        },
        {
            Header: "Flete",
            accessor: "Flete",
            maxWidth: 100,
            Cell: row => <div style={{textAlign: "right"}}>{row.value}</div>

        },
        {
            Header: "Cantidad",
            accessor: "Cantidad",
            maxWidth: 100,
            Cell: row => (
                <div style={{textAlign: "right"}}>
                    <EditableQuantityInput
                        item={row.original}
                        initialValue={row.value}
                        onQuantityChange={handleQuantityUpdate}
                    />
                </div>
            )
        },
        {
            Header: "Total",
            accessor: "Total",
            maxWidth: 100,
            Cell: row => <div style={{textAlign: "right"}}>{decimalAdjust('floor', row.value, -2)}</div>
        },
        {
            Header: "Acciones",
            accessor: "IdDetalleOC",
            Cell: (f) => {
                return (
                    <div align='center'>
                        <BotonMenosPequeño
                            className="ml-2"
                            type="button"
                            title="Disminuir en 1"
                            onClick={
                                () => props.handleAddQuantityItem(f.original, -1)
                            }
                        />
                        <BotonAddPequeño
                            type="button"
                            title="Aumentar en 1"
                            className="ml-2"
                            onClick={
                                () => props.handleAddQuantityItem(f.original, 1)
                            }
                        />
                        <BotonRemovePequeño
                            title="Eliminar"
                            type='button'
                            className="ml-2"
                            onClick={
                                () => props.handleEliminarItem(f.original)
                            }
                        />
                    </div>
                )
            },
        },
    ], [handleQuantityUpdate, props.handleAddQuantityItem, props.handleEliminarItem])

    return (
        <ReactTable
            data={rows}
            disabled={false}
            columns={columns}

            defaultPageSize={20}
            showPagination={true}
            style={{
                height: "600px",
                width: "100%",
                fontSize: "13px"
            }}
            className="-striped -highlight"
        />
    )

}

export default MovimientoAlmacenDetalle
